import { ApiResponseType } from './api';
import { GridSortEnum } from './grid';

export enum OfferStateEnum {
    pending,
    accepted,
    rejected,
    retracted,
    expired,
    onboarded,
    ghosted,
}

export enum OfferCreationEnum {
    newOffer,
    reOffer,
}

export enum OfferReviewStateEnum {
    offerIsNotInAppropriateStateForReview,
    startDateNotReached,
    availableForReview,
    reviewAlreadyExists,
    thereIsNoOffer,
}

export enum AutomaticReminderEnum {
    never,
    every1Day,
    every2Day,
    every3Day,
    every1Week,
}

export enum FeedbackExperienceEnum {
    VeryBad,
    Bad,
    Average,
    Good,
    Excellent,
}

export enum OfferType {
    NormalOffer = 0,
    COE = 1,
    CoeOnOffer = 2,
    Offline = 3,
    External = 4,
    DataPunch = 5,
}

export type OfferListRquestType = {
    state: OfferStateEnum;
    start: number;
    limit: number;
    sortField: string;
    sortOrder: GridSortEnum;
    startDate?: Date;
    endDate?: Date;
};

export type OfferRequestDataType = {
    jobTitle: string;
    offerExpiryDate: string;
    jobStartDate: string;
    timeZone: string;
    candidateId: string;
    emailSubject: string;
    emailMessage: () => string | undefined;
    emailMessageContent: string;
    automaticReminder: number;
    ReOfferId?: string;
    offerType: OfferType;
};

export type OfferRequestFeedbackType = {
    offerId: string | null;
    feedbackExperience: FeedbackExperienceEnum | null;
    FeedbackRecommendation: FeedbackRecommendationEnum | null;
    text: string;
};

export type CreateOfferResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        value: string;
    };
};

export type OfferDataType = {
    id: string;
    jobTitle: string;
    offerExpiryDate: Date;
    jobStartDate: Date;
    offerDate: Date;
    offerRealeasedById: string;
    offerRealeasedByLastName: string;
    offerRealeasedByFirstName: string;
    companyId: string;
    companyName: string;
    companyAvatarUrl: string;
    candidateId: string;
    candidateFirstName: string;
    candidateMiddleName: string;
    candidateLastName: string;
    candidateNumber: number;
    candidateJobTitle: string;
    candidateAvatarUrl: string;
    offerDocumentId: string;
    offerDocumentUrl: string;
    offerState: OfferStateEnum;
    acceptedDate: Date | null;
    rejectedDate: Date | null;
    retractedDate: Date | null;
    expiredDate: Date;
    offerReviewState: OfferReviewStateEnum;
    externalForSignatureDocId: string;
    baseOfferId: string | null;
    offerCreationType: OfferCreationEnum;
    offerRejectionReasons: offerRejectionReasonType[];
    offerRetractReasons: offerRetractReasonsType[];
    reviewType: number[];
    reviewOffers: ReviewOfferType[];
    coeID?: string;
    offerType: number;
    isOnboardingRevieweditable: boolean;
    isoffboardingReviewEditable: boolean;
    onboardingReviewDate: string;
    offboardingReviewDate: string;
    onboardingReviewId: string | null;
    offboardingReviewId: string;
    onboardingReviewEditedTimesAndReplyCount: number[];
    offboardingReviewEditedTimesAndReplyCount: number[];
};

export type Base64RequestType = {
    documentId: string;
    documentType?: string;
    countryId?: string;
};

export type Base64DefaultDocumentRequestType = {
    countryId?: string;
};

export type getCOEActiveOrNotRequestType = {
    candidateId: string;
    timeZone: string;
    reofferId?: string | null;
};

export type getCOEActiveOrNotResponseType = {
    resultObject: {
        isCOEActive: boolean;
    };
};

export type Base64DataResponseType = {
    documentId: string;
    documentName: string;
};

export type offerRetractReasonsType = {
    id: string;
    reasonId: string;
    reason: string;
    order: number;
    reasonText: string;
};

export type offerRejectionReasonType = {
    id: string;
    reasonId: string;
    reason: string;
    reasonText: string;
    order: number;
};

export type RejectionReasonType = {
    id: string;
    reason: string;
    order: number;
};

export type RejectionReasonRequestType = {
    offerId: string;
    rejectionReasonList: string[];
    reasonText: string | null;
};

export type RetractReasonRequestType = {
    offerId: string;
    retractReasonList: string[];
    reasonText: string | null;
};

export type RetractReasonResponseType = {
    isOfferExists: boolean;
};

export type GetAllRetractReasonsListType = {
    id: string;
    reason: string;
    order: number;
};

export type GetAllRetractReasonsListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: GetAllRetractReasonsListType[];
    };
};

export type RetractResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: RetractReasonResponseType;
};

export type OfferListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: OfferDataType[];
        hasMore: boolean;
        count: number;
    };
};

export type OfferResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: OfferDataType;
};

export type Base64ResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: Base64DataResponseType;
};

export type RejectionReasonResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: RejectionReasonType[];
        hasMore: boolean;
        count: number;
    };
};

export type ExternalSignatureAccessTokenResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        id: string;
    };
};

export type ReviewOfferType = {
    jobRole: string;
    jobStartDate: Date;
    offerId: string;
    onboardingReviewCount: number;
    exitReviewCount: number;
    offerType: number;
    offerState: OfferStateEnum;
};

export enum FeedbackRecommendationEnum {
    VeryUnlikely,
    SomeWhatUnlikely,
    Neutral,
    SomeWhatlikely,
    VeryLikely,
}
